
import React from "react";
import { MapPin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import AddressMap from "./AddressMap";

const Footer = () => {
  const { language } = useLanguage();
  
  const content = {
    fr: {
      privacyLink: "Confidentialité",
      termsLink: "Conditions",
      contactLink: "Contact",
      copyrightText: "Tous droits réservés.",
      visitUs: "Où sommes-nous"
    },
    en: {
      privacyLink: "Privacy",
      termsLink: "Terms",
      contactLink: "Contact",
      copyrightText: "All rights reserved.",
      visitUs: "Where we are"
    },
    de: {
      privacyLink: "Datenschutz",
      termsLink: "Bedingungen",
      contactLink: "Kontakt",
      copyrightText: "Alle Rechte vorbehalten.",
      visitUs: "Wo wir sind"
    }
  };

  return (
    <footer className="bg-gradient-to-b from-white via-gray-50/50 to-legatia-light/30 border-t border-gray-100 py-20 md:py-28 px-4 relative overflow-hidden">
      {/* Enhanced background decorations */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-20 right-[10%] w-64 h-64 bg-gradient-to-r from-legatia-blue/8 to-legatia-green/8 rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 left-[15%] w-48 h-48 bg-gradient-to-r from-legatia-yellow/6 to-legatia-orange/6 rounded-full blur-2xl"></div>
        <div className="absolute top-1/3 left-1/4 w-3 h-3 bg-legatia-blue/30 rounded-full animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/3 w-4 h-4 bg-legatia-green/25 rounded-full animate-pulse" style={{ animationDelay: "1s" }}></div>
      </div>
      
      <div className="container mx-auto max-w-6xl relative z-10">
        {/* Location section */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-white/90 backdrop-blur-sm p-8 rounded-2xl shadow-lg border border-gray-100">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-r from-legatia-blue/15 to-legatia-green/15 rounded-xl flex items-center justify-center">
                <MapPin className="h-6 w-6 text-legatia-blue" />
              </div>
              <h3 className="font-bold text-xl text-gray-900">{content[language].visitUs}</h3>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8 items-start">
              <div>
                <address className="not-italic text-gray-600 space-y-1 mb-4">
                  <p className="font-semibold text-gray-900">Legatia SA</p>
                  <p>Rue des Jeuneurs</p>
                  <p>75002 Paris, France</p>
                </address>
              </div>
              
              <div>
                <AddressMap 
                  address="Rue des Jeuneurs, 75002 Paris, France" 
                  className="rounded-xl shadow-sm"
                />
              </div>
            </div>
          </div>
        </div>
        
        {/* Footer links */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} Legatia. {content[language].copyrightText}
            </p>
            
            <div className="flex items-center space-x-8">
              <a href="#" className="text-gray-500 hover:text-legatia-blue transition-colors duration-200 text-sm font-medium">
                {content[language].privacyLink}
              </a>
              <a href="#" className="text-gray-500 hover:text-legatia-blue transition-colors duration-200 text-sm font-medium">
                {content[language].termsLink}
              </a>
              <a href="#" className="text-gray-500 hover:text-legatia-blue transition-colors duration-200 text-sm font-medium">
                {content[language].contactLink}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
